<script>
import HeaderComponent from "@/components/HeaderComponent.vue";
import SlideMenuComponent from "@/components/SlideMenuComponent.vue";
import {ElMessage} from "element-plus";
import {mapState} from "vuex";
import axios from "@/utils/axios";
import {short_address, short_address2, timeAgo} from "../utils/utils";

export default {
  name: "MyTeamView",
  components: {SlideMenuComponent, HeaderComponent},
  data: function () {
    return {
      directReferralQuantity: 0,
      personalAchievements: 0,
      todayNewPerformance: 0,
      teamPerformance: 0,
      myLevel: "V0",
      interval: null,
      allInvited: [],
    }
  },
  computed: {
    ...mapState(['wallet_address', 'wallet_type']), // 映射 state
    myInvitorUrl: () => {

      // if (!this.wallet_address) {
      //   return "";
      // }


      return "https://ai-r1.com?invitor="
    },
    currentRoute() {
      return this.$route.path; // Get the current route path
    },
  },
  methods: {
    short_address2,
    timeAgo,
    short_address,
    async copy(text) {
      // window.navigator && window.navigator.clipboard && window.navigator.clipboard.writeText(text);
      try {
        // 尝试使用 Clipboard API 复制
        await navigator.clipboard.writeText(text);
        ElMessage.success('Success copied to clipboard.');
      } catch (err) {
        // 如果 Clipboard API 失败，使用临时文本框来复制
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        ElMessage.success('Success copied to clipboard.');
      }

    },
    onClickCopy() {
      console.log("onClickCopy", this.wallet_address)
      if (this.wallet_address) {
        this.copy('https://ai-r1.com?invitor=' + this.wallet_address)
      } else {
        ElMessage.error("Please connect your wallet")
      }
    },
    async load() {
      if (this.wallet_address) {
        const resp = await axios.get("/api/team/" + this.wallet_address)
        if (resp.data.code === 0) {
          this.directReferralQuantity = resp.data.data.allInvited.length;
          this.personalAchievements = resp.data.data.personal_achievements;
          this.teamPerformance = resp.data.data.team_achievements;
          this.todayNewPerformance = resp.data.data.today_achievements;
          this.allInvited = resp.data.data.allInvited;
          this.myLevel = resp.data.data.my_level;
        }

      }
    }
  }
  ,
  mounted() {
    this.load();

    this.interval = setInterval(() => {
      this.load()
    }, 3 * 1000)
  }
  ,
  unmounted() {
    clearInterval(this.interval)
  }
}
</script>

<template>
  <div>
    <HeaderComponent/>
    <SlideMenuComponent/>
    <div class="index">
      <div class="section8">
        <div class="block2">
          <div class="title">
            <div class="lef">
              <img src="images/cir3.png" alt="">
              <span>{{ $t('myTeam') }}</span>
            </div>
            <div class="ris">
              <a href="javascript:" @click="onClickCopy">{{ $t('copyInvitationLink') }}</a>
            </div>
          </div>
          <div class="content">
            <div class="dec">
              <p>
                <span class="s1">{{ $t('myInvitationLink') }}</span>
              </p>
              <p>
                <span class="s1">{{ "https://ai-r1.com?=" + short_address(wallet_address) }}</span>
              </p>
              <p>
                <span class="s1">{{ $t('directReferralQuantity') }}</span>
                <span class="s2">{{ directReferralQuantity }}</span>
              </p>
              <p>
                <span class="s1">{{ $t('personalAchievements') }}</span>
                <span class="s2">{{ personalAchievements }}</span>
              </p>
              <p>
                <span class="s1">{{ $t('teamPerformance') }}</span>
                <span class="s2">{{ teamPerformance }}</span>
              </p>
              <p>
                <span class="s1">{{ $t('todaysNewPerformance') }}</span>
                <span class="s2">{{ todayNewPerformance }}</span>
              </p>
              <p>
                <span class="s1">{{ $t('myLevel') }}</span>
                <span class="s2"> {{ myLevel }}</span>
              </p>
              <p>
                <span class="s1">{{ $t('directRecommendationList') }}</span>
                <span class="s2"><a href="javascript:;" class="slide"></a></span>
              </p>
              <div class="last">
                <table width="100%" border="0" cellspacing="0" cellpadding="0" class="">
                  <tr>
                    <th>{{ $t("address") }}</th>
                    <th>{{ $t("performance") }}</th>
                    <th>{{ $t("time") }}</th>
                  </tr>
                  <tr v-for="item in allInvited" :key="item.id">
                    <td>{{ short_address2(item.walletAddress) }}</td>
                    <td>{{ item.baseHashRate / 100 }}</td>
                    <td>{{ (item.createdAt.substr(5, 5)) }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>